export default "__VITE_ASSET__j_t$rqtM__"